const prodEdConfig = {
  name: 'prod',
  ampContent: 'https://www.hmhco.com/content',
  ampLoggedInURL: 'https://www.hmhco.com/ui/logged-in/',
  ampSignedInURL: 'https://www.hmhco.com/ui/signed-in/',
  ampLogin: 'https://www.hmhco.com/ui/login',
  ampLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  ampLoginPrivacyPolicy:
    'https://www.hmhco.com/prek-12-products-privacy-policy',
  ampLoginTermsAndConditions:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  hnmLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Flight/LogIn/',
  hnmLoginPrivacyPolicy:
    'https://www.heinemann.com/privacy/?utm_medium=shorturl&utm_source=privacy',
  hnmLoginTermsAndConditions:
    'https://www.heinemann.com/platforms-terms-of-use/?utm_medium=shorturl&utm_source=platform-terms',
  rootUrl: 'https://www.hmhco.com/ui/',
  loginUrl: 'https://www.hmhco.com/ui/login/',
  loggedInUrl: `https://www.hmhco.com/ui/logged-in/`,
  loggedOutUrl: `https://www.hmhco.com/ui/login/logged-out/`,
  helpUrl: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  privacyPolicyUrl: 'https://www.hmhco.com/prek-12-products-privacy-policy',
  termsAndConditionsUrl:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  apiEngHostname: 'https://api.hmhco.com',
  apiEngHostnamePublic: 'https://papi.hmhco.com',
  assessments: 'https://www.hmhco.com/api/assessment',
  assignments: 'https://www.hmhco.com/api/assignment',
  assignmentK8s: 'https://www.hmhco.com/api/assignment',
  authorizationApi: 'https://www.hmhco.com/api/authorization',
  auth0: 'https://hmhco.auth0.com',
  auth0CreateConnectionsHost:
    'https://papi.hmhco.com/auth-self-service-setup/api/v1/sso',
  auth0FetchConnectionsHost:
    'https://papi.hmhco.com/auth-self-service-setup/api/v1/sso/datastore/connection',
  amiraReports: 'https://teacher.app.amiralearning.com/dashboard',
  baseURL: 'https://www.hmhco.com/one',
  cdsMetadatapipeline: 'https://api.eng.hmhco.com/cds-metadatapipeline',
  classes: 'https://www.hmhco.com/ui/classes',
  classesClasses: 'https://www.hmhco.com/ui/classes/classes',
  clientRegistry: 'https://papi.hmhco.com/idm-client-registry',
  collaboration: 'collaboration.hmhco.com',
  contentProvider: 'http://www.hmhco.com/ui/#/contentProvider/',
  districtDownloadApi: 'https://papi.hmhco.com/data-district-download-service',
  districtDownloadApiK8s:
    'https://hapi.hmhco.com/data-district-download-service/',
  ebrCore: 'https://papi.hmhco.com/idm-ebr-core',
  ebrUi: 'https://www.hmhco.com/import/',
  edHostname: 'https://www.hmhco.com/',
  edBaseUrl: 'https://www.hmhco.com',
  EDSLoginUrl: 'https://hapi.hmhco.com/edcore/eds-login',
  EDSResourceUrl: 'https://api.heinemann.com',
  grading: 'https://www.hmhco.com/api/grading/',
  gradingK8s: 'https://hapi.hmhco.com/grading-api/',
  hmhHelpCenter: 'http://downloads.hmlt.hmco.com',
  hmoHostname: 'https://my.hrw.com/sp/',
  hmoLoginPath: 'https://my.hrw.com/index.jsp',
  idm: 'https://idm.api.hmhco.com/openid-connect',
  jasperReporting: 'https://www.hmhco.com/jasperserver-pro',
  licenses: 'https://www.hmhco.com/ui/#/licenses',
  liftRoot: 'https://www.hmhco.com/ui/',
  loginPath: '/login/',
  ltiCache: 'https://papi.hmhco.com/lti-deep-linking/cache',
  myClasses: 'https://www.hmhco.com/ui/!my-classes',
  myStuff: 'https://www.hmhco.com/ui/#/my-stuff/lessons',
  newNotificationsApi: 'https://hapi.hmhco.com',
  nweaBaseUrl: 'https://auth.nwea.org/adult/',
  nweaStartPage: 'https://auth.nwea.org/adult/login/',
  nweaCommonRosterRedirectUrl:
    'https://teach.mapnwea.org/admin/importprofile/StartNewImportPage.seam',
  oktaConnectionApi: 'https://papi.hmhco.com/okta-services-gateway/api/v1/sso',
  oktaFetchConnectionsHost:
    'https://papi.hmhco.com/okta-services-gateway/api/v1/sso/idps',
  oktaNewOrg: 'https://papi.hmhco.com/okta-services-gateway/api/v1/org',
  onesearch: 'https://www.hmhco.com/api/onesearch/v1',
  picker: 'https://www.hmhco.com/ui/#/picker/',
  plannerHost: 'https://papi.hmhco.com/planner-api',
  plannerHostNonWaf: 'https://api.eng.hmhco.com/planner-api',
  plsAuthors: 'https://papi.hmhco.com/pls-services-author/api/v5/authors',
  plsCollections:
    'https://papi.hmhco.com/pls-services-resource/api/v5/collections',
  plsCollectionsK8:
    'https://hapi.hmhco.com/pls-services-resource/api/v5/collections',
  plsLessonRelatedResource:
    'https://papi.hmhco.com/pls-services-lessonrelatedresource/api/v5/lessonrelatedresources',
  plsLessonRelatedResourceK8:
    'https://hapi.hmhco.com/pls-services-resource/api/v5/lessonrelatedresources',
  plsRelatedResources:
    'https://papi.hmhco.com/pls-services-relatedresource/api/v5/relatedresources',

  plsRelatedResourcesK8:
    'https://hapi.hmhco.com/pls-services-resource/api/v5/relatedresources',
  plsResource: 'https://papi.hmhco.com/pls-services-resource/api/v5/resources',
  plsResourceK8:
    'https://hapi.hmhco.com/pls-services-resource/api/v5/resources',
  prefixCDS: 'https://cds-metadatapipeline.br.hmheng.io',
  reportDownloadK8s: '/reporting-api/v5/programs/schoolAssessment',
  reportDownloadK8sBaseURL: 'https://hapi.hmhco.com',
  restApi: 'https://papi.hmhco.com',
  restGroupLessonApi: 'https://practice.gogetwaggle.com/teacher',
  restHapi: 'https://hapi.hmhco.com',
  restDMPS: 'https://papi.hmhco.com/dmps',
  restDMPSNonWAF: 'https://api.eng.hmhco.com/dmps',
  restELM: 'https://elm.br.hmheng.io/v1',
  restIdsApi: 'https://api.br.internal/ids', // for purging users in IDS we need a different API
  restIdsGridApi: 'https://papi.hmhco.com/ids-grid-api',
  hcpIdentityApiGateway: 'https://hapi.hmhco.com/hcp-identity-api-gateway',
  restIdsGridApiNonWAF: 'https://api.eng.hmhco.com/ids-grid-api',
  restOAC: 'https://oac.br.hmheng.io/v3',
  restOACNonWAF: 'https://oac.br.hmheng.io/v3',
  restOacV2: 'https://www.hmhco.com/api/oac/v2',
  restPostPrefix: 'https://www.hmhco.com',
  restPrefix: 'https://www.hmhco.com',
  restRecommendation: 'https://papi.hmhco.com/recommendation-api',
  restRecommendationK8: 'https://hapi.hmhco.com/recommendation-api-svc',
  restStagingProcessor: 'https://papi.hmhco.com/idm-staging-processor',
  restSusApi: 'https://api.br.internal/idm-user-api', // for purging users in SUS
  restUdsApi: 'https://papi.hmhco.com/uds',
  reportingSftpService: 'https://hapi.hmhco.com/reporting-sftp-svc',
  rosterDashboard: 'https://www.hmhco.com/ui/#/roster',
  r180Api: 'https://www.hmhco.com/api/r180/',
  r180Media: 'https://www.hmhco.com/r180/media',
  sisHostname: 'https://www.hmhco.com/',
  sso: 'https://papi.hmhco.com/auth-self-service-setup',
  ssoInitializeUrl: 'https://papi.hmhco.com/login/initialize',
  storyBook: 'https://www.hmhco.com/ui/storybook/',
  susAuth: 'https://www.hmhco.com/api/authorization',
  standardsReportWritableResources:
    'https://www.hmhco.com/ui/#/allResources/discipline/standards?disciplineCode=ED18_RLA&abGuid=802F94DA-7440-11DF-93FA-01FD9CFF4B22&domainId=286EE5CC-74F7-11DF-80DD-6B359DFF4B22&domainName=Writing&studentId=all&schoolId=null&teacherId=b3665c26-b096-4c3f-8df7-314d9bb762b5',
  standardsReportWaggleResources:
    'https://www.hmhco.com/ui/#/allResources/discipline/standards?disciplineCode=ED18_MATH&abGuid=1BD4F4C6-7053-11DF-8EBF-BE719DFF4B22&domainId=1BCEA21A-7053-11DF-8EBF-BE719DFF4B22&domainName=Operations+and+Algebraic+Thinking&studentId=all&schoolId=null&teacherId=b3665c26-b096-4c3f-8df7-314d9bb762b5',
  tcHostname: 'https://www-k6.thinkcentral.com/sp/',
  tcLoginPath: 'https://www-k6.thinkcentral.com/ePC/start.do',
  linkedAssignments:
    'https://www.hmhco.com/ui/#/assign-full?resourceId=l_ff9bdd36-f627-4241-8dbc-9f9b4f158f56_c7b06f27-597b-42fc-8169-67247568e97f&programId=IM_NL20_G4&title=Unit+Opener%3A+Place+Value+and+Whole+Number+Operations&backTo=discover%252FIM_NL20_G4%252F1&showSched=true&recBy=NONE&isSgm=false',
  virtualClassroomApi:
    'https://papi.hmhco.com/vcservice/v2/virtual-classroom/meeting',
  wormhole: 'https://papi.hmhco.com/wh-api/graphql',
  wormholek8s: 'https://hapi.hmhco.com/wormhole-api/graphql',
  importingService: 'https://papi.hmhco.com/idm-api-importing-service',
  apiBaseURL: '',
  featureFlagURL:
    'https://www.hmhco.com/ui/flags/featureFlagsCohorts.config.json',
  edsApiGateway: 'https://hapi.hmhco.com/edcore/hmheng-eds-api-gateway/',
  edsCoreApp: 'https://hapi.hmhco.com/edcore/eds-core-app/',
  edsAuthorize: 'https://hapi.hmhco.com/edcore/eds-login/login/authorize',
  edsAuthorizationCode:
    'https://hapi.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  edsInitUrl: 'https://hapi.hmhco.com/edcore/eds-login/login/initializeUri',
  edsLogoutUrl: 'https://hapi.hmhco.com/edcore/eds-login/logout/',
  edsPostLogoutRedirectUrl: 'https://www.hmhco.com/ui/login/',
  flightLogin: 'https://platform.heinemann.com/ui/login/',
  forgotPassword: '/ui/login/forgot-password/',
  requestSigninDetails: '/ui/login/request-signin-details/',
  plsCollaborationArtifacts:
    'https://hapi.hmhco.com/collaboration-artifacts-svc',
  planktonBaseUrl: 'https://d16qzots3do3wk.cloudfront.net/',
  edpsUrl: 'https://hapi.hmhco.com/edcore/hmheng-eds-api-gateway/',
  plsCoachingTopicURL: 'https://papi.hmhco.com/pls-services-resource/api/v1',
  plsCoachingTopicURLK8: 'https://hapi.hmhco.com/pls-services-resource/api/v1',
  plsCoachingTopicURLK8V2:
    'https://hapi.hmhco.com/pls-services-resource/api/v2',
  getUserUrl: 'https://papi.hmhco.com/ids-grid-api/ids/v1',
  getClassUrl: 'https://papi.hmhco.com/ids-grid-api/ids/v2',
  deleteUserUrl: 'https://papi.hmhco.com/ids-grid-api/ids/v1/purge/users',
  createStudentUrl: 'https://papi.hmhco.com/ids-grid-api/ids/v1/students',
  iReadApiUrl: 'https://www.hmhco.com/api/iread',
  plannerURL: 'https://papi.hmhco.com/planner-api/',
  assessmentsK8: 'https://www.hmhco.com/api/assessment',
  proctorApiUrl: 'https://colo-gateway.nwea.org',
  testsApiUrl: 'https://colo-gateway.nwea.org',
  NWEA_TOKEN_SWAP_CLIENT_ID: '8ea569aea2cc4f0ab94f6759f1141188',
  NWEA_TOKEN_SWAP_SECRET: 'fJeebhL0TSoP-1tq1CxZ90-nJ9-fWjN-HP0H3cH6xLQ',
  NWEA_TOKEN_SWAP_HOST: 'https://access.auth.nwea.org',
  partnerConfigUrl: 'https://colo-gateway.nwea.org',
  waggleApi: 'https://hapi.hmhco.com/waggle-placement-svc/api/v1/waggle',
  plsIntegrationSvc: 'https://hapi.hmhco.com/pls-integration-svc',
  ltiDeepLinkingEnrollTeacher:
    'https://papi.hmhco.com/lti-deep-linking/jitr/enroll/teacher',
  plsActivitySvc: 'https://hapi.hmhco.com/pls-activity-svc',
};

module.exports = prodEdConfig;
